module.exports = __webpack_public_path__ + "img/wa-round-icon.69ffd1ca.svg";